export const webCam = ({ videoId, canvasId }) => {
  let width = 0;
  let height = 0;

  return {
    video: null,
    context: null,
    canvas: null,
    stream: null,

    startCamera: function(w = 500, h = 375) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        width = w;
        height = h;

        this.video = document.getElementById(videoId);
        this.canvas = document.getElementById(canvasId);
        this.context = this.canvas.getContext('2d');

        navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
          this.video.srcObject = stream;
          this.stream = stream;
          this.video.play();
        });
      }
    },
    takeSnapshot: function() {
      this.context.drawImage(this.video, 0, 0, width, height);
      this.stream?.getTracks().forEach(track => {
        track.stop();
      });
      return this.canvas.toDataURL('image/png');
    },
  };
};
